module.exports = __webpack_public_path__ + "img/78600.3bddeb9c.jpg";